import React from 'react';
//import FacebookVideoGallery from '../Components/FacebookVideoGallery';
import YouTubeGallery from '../Components/YouTubeGallery';
import ImageCarousel from '../Components/ImageCarousel';
import { useTranslation } from "react-i18next";

function VideoGallery() {
  const { t } = useTranslation();

  return (
    <div className="galleryContainer headerMargin">
      
      <section id="videoGallery" className="section tricolor-background">
        <h2 className="pb50">{t('media.subtitle_1')}</h2>
        <div className="vsection">
          <ImageCarousel />
        </div>
        
        
        <YouTubeGallery />
        

        {/* <div className="vsection">
          <FacebookVideoGallery />
        </div> */}

      </section>
    </div>
  );
}

export default VideoGallery;